<template>
  <div class="booking__item-inner" :class="{ 'is-open': showList }">
    <div v-click-outside="close">
      <div class="booking__input" @click="showDefaultNationalityList">
    

        <div class="booking__input-inner">
          <label class="booking__input-label">ملیت</label>
          <span >
            {{ inputValue ? inputValue : "انتخاب ملیت" }}
          </span>
        </div>
      </div>

      <div class="booking__list">
        <div
          class="hide-in-desktop booking__item-header booking__item-header--bg"
        >
          <span>انتخاب ملیت</span>
          <button @click="close">
            <i class="icon-close"></i>
          </button>
        </div>

        <div class="booking__list-input form">
          <div
            class="form-element-group form-element-group--with-icon form-element-group--icon-right"
          >
            <div>
              <i class="icon-search"></i>
              <input
                type="text"
                v-model="inputValue"
                placeholder="ملیت را جستجو کنید ..."
                class="js-nationality-item"
                ref="innerInput"
                @input="gethNationalityList"
                @keyup.esc="close"
                autocomplete="off"
              />
            </div>
          </div>
        </div>

        <div class="booking__list-inner">
          <div v-if="showLoading" class="booking__list-loading">
            <svg
              class="circle-loading"
              viewBox="0 0 120 120"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
              <circle class="external-circle" cx="60" cy="60" r="50"></circle>
            </svg>
          </div>

          <div v-if="!showLoading">
            <div v-if="nationalityList.length" class="booking__list-item">
              <ul>
                <li
                  v-for="nationality in nationalityList"
                  :key="nationality.key"
                  :class="{ hide: !nationality.name_fa }"
                  class="booking__result"
                >
                  <div class="booking__result-content" @click="setValue(nationality)">
                    <i class="booking__result-icon icon-location-fill" />

                    <div class="booking__result-inner">
                      <span>{{ nationality.name_fa }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <span
              class="booking__validation"
              v-if="notFound && !showDefaultList"
              >موردی یافت نشد</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { nationalityList } from "../../../../ConstantData/constants";
import { modelMapper } from "../../../../Mappers";
import { clickOutside } from "../../../../Helpers/directives";

// select html tag
const root = document.getElementsByTagName("html")[0];

export default {
  name: "Nationality",

  data() {
    return {
      inputValue: "ایران",

      nationalityCode: "Ir",

      showList: false,

      nationalityList: [],

      defaultList: modelMapper(nationalityList),

      showDefaultList: true,

      notFound: false,

      selectedNationality: true,

      showLoading: false,

      temp: "",

      setTimeout: "",
    };
  },

  methods: {
    // show defaul list
    showDefaultNationalityList() {
      this.$emit("scroll-to-booking-section", this.$el);

      this.showList = true;
      this.showDefaultList = true;
      this.nationalityList = this.defaultList;
      this.notFound = false;
      this.temp = this.inputValue;
      this.inputValue = "";
      
     if (window.innerWidth < 993) {
      root.classList.add("no-scroll");
     }

      this.setTimeout = setTimeout(() => {
        this.$refs.innerInput.focus();

        clearTimeout(this.setTimeout);
      }, 100);
    },

    // set input value
    setValue(nationality) {
      this.inputValue = nationality.name_fa;
      this.nationalityCode = nationality.code;
      this.showList = false;
      this.selectedNationality = true;
      this.temp = "";      

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }

      this.$emit("remove-search-holder-z-index");

      this.$emit("fill-next-input");
    },

    // search nationality when type in input
    gethNationalityList() {
      this.showLoading = true;
      this.showDefaultList = false;
      this.showList = true;
      this.selectedNationality = false;

      clearTimeout(this.setTimeout);

      this.setTimeout = setTimeout(() => {
        this.nationalityList = [];

        let regExp = new RegExp(this.inputValue.toLowerCase(), "i");

        let filteredItems = modelMapper(nationalityList).filter(
          (item) => {
            return item.name_fa.match(regExp);
          }
        );

        if (filteredItems.length) {
          this.nationalityList = filteredItems;
        } else {
          this.nationalityList = [];
          this.notFound = true;
        }

        this.showLoading = false;

        this.$refs.innerInput.focus();
      }, 400);
    },

    // clear input value
    clearInput() {
      this.inputValue = "";
      this.nationalityCode = "";
      this.selectedNationality = false;
      this.temp = "";
    },

    // close dropdown when click out of booking section
    close() {
      if (this.showList) {
        this.showList = false;        

        if (window.innerWidth < 993) {
          root.classList.remove("no-scroll");
        }

        if (this.temp) {
          this.inputValue = this.temp;
        }

        this.$emit("remove-search-holder-z-index");
      }

      if (!this.selectedNationality) {
        this.temp = "";
        this.inputValue = "";
        this.nationalityCode = "";
      }
    },
  },

  directives: {
    "click-outside": clickOutside,
  },
};
</script>
